import { render, staticRenderFns } from "./replaceGoodsDetail.vue?vue&type=template&id=f33cb1c4"
import script from "./replaceGoodsDetail.vue?vue&type=script&lang=js"
export * from "./replaceGoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./replaceGoodsDetail.vue?vue&type=style&index=0&id=f33cb1c4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports